import {
  FiBriefcase,
  FiScissors,
  FiSearch,
  FiSliders,
  FiTrendingUp,
  FiVolume2,
} from 'react-icons/fi';

/** Brand accent for team member / assigned-team modals (matches app primary gradient tone). */
export const TEAM_MEMBER_MODAL_ACCENT = '#667eea';
export const TEAM_MEMBER_MODAL_ICON_TILE_BG = 'rgba(102, 126, 234, 0.14)';
export const TEAM_MEMBER_MODAL_HEADER_TILE_BG = 'rgba(102, 126, 234, 0.16)';

/**
 * Feather icon for a role label (keyword heuristics for common production roles).
 * @param {string} roleLabel
 * @returns {import('react-icons').IconType}
 */
export function getRoleIconComponent(roleLabel) {
  const r = String(roleLabel || '').toLowerCase();
  if (r.includes('analyz')) return FiSearch;
  if (r.includes('cut')) return FiScissors;
  if (r.includes('mixer') || r.includes('obs')) return FiSliders;
  if (r.includes('sound')) return FiVolume2;
  if (r.includes('track')) return FiTrendingUp;
  return FiBriefcase;
}
